
<template>
    <div style="height: 100%;">
      <main-header :isCollapsed="isCollapsed"></main-header>
      <main-sider :isCollapsed.sync="isCollapsed"></main-sider>
      <Layout>
        <Content :id="isCollapsed ? 'collapsedmain' : 'main'">
          <main-nav-tabs ></main-nav-tabs>
          <div :style="{ margin: '0 20px 0', minWidth: '1280px' }">
            <router-view class="view one" v-if="isRouterAlive"  ></router-view>
            <Spin fix v-show="isLoadingStatus" style="background: rgba(0 ,0, 0, .64)" >
              <div class="loading-content _alignmiddle">
                <Icon type="ios-loading" size="18" class="demo-spin-icon-load mr-2"></Icon>
                <span class="loading-text"> 资料处理中....请勿关闭或重整网页</span>
              </div>
            </Spin>
          </div>
          <Footer class="text-center"><Copyright /></Footer>
        </Content>
      </Layout> 
    </div>
</template>

<script>
import mainHeader from '@/components/main/header'
import mainSider from '@/components/main/sider'
import mainNavTabs from '@/components/main/navtabs'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    mainHeader,
    mainSider,
    mainNavTabs
  },
  provide () {
    return {
      reload: this.reload,
      LoadingShow: this.LoadingShow
    }
  },
  data() {
    return {
      isRouterAlive: true,
      isLoadingStatus: false,
      tiemr: null,
      isCollapsed: false
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  created () {
    clearInterval(this.tiemr)
    this.isregin()
    this.isreginTime()
  },
  beforeDestroy () {
    clearInterval(this.tiemr)
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    async LoadingShow(state) {
      this.isLoadingStatus = state
    },
    async isregin () {
      const member = await this.$localForage.getItem('member')
      if(!member) return 
      try {
        const res = await this.$axios.isregin({loid: member.pid, logdate: member.logdate})
        if (res.status != '1') {
          this.$router.push({name: 'login'})
        }
      } catch (error) {
        console.log(error);
      }
    },
    isreginTime () {
      this.tiemr = setInterval(() => this.isregin(), 10000)
    }
  }
};
</script>

<style >
#logotitle {
  color: aliceblue;
}
#main {
  background: #e9e9e9; /* Old browsers */
  position: absolute; 
  top: 60px; 
  right: 0;
  left: 200px;  
  bottom:0;
  transition: left .1s ease .1s;
   /* overflow-y: scroll; */
}
#collapsedmain {
  background: #e9e9e9;
  position: absolute; 
  top: 60px; 
  right: 0;
  left: 75px;  
  bottom:0;
  transition: left .1s ease .1s;
}
.loading-content {
  vertical-align: middle;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 15px 30px;
  border-radius: 8px;
  box-shadow: 0 0 10px #000;
  text-align: left;
}
.loading-text {
   color: #000;
   font-size: 14px;
}
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
     color: #000;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
</style>